import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    autoDismiss: { type: Boolean, default: true },
    duration: { type: Number, default: 5000 }
  }

  connect() {
    // Set initial state for animation
    this.element.style.transform = "translateX(100%)"
    this.element.style.opacity = "0"
    this.element.style.transition = "transform 300ms ease-out, opacity 300ms ease-out"

    // Trigger slide-in animation
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.element.style.transform = "translateX(0)"
        this.element.style.opacity = "1"
      })
    })

    if (this.autoDismissValue) {
      this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    this.element.style.transform = "translateX(100%)"
    this.element.style.opacity = "0"
    setTimeout(() => this.element.remove(), 300)
  }
}
